import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { SecurityService } from './security.service';
import { firstValueFrom, from } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

export const authGuard: CanActivateFn = (route, state) => {
  const securityService = inject(SecurityService);
  const router = inject(Router);

  const redirectToLogin = (router: Router, returnUrl: string) => {
    localStorage.setItem('returnUrl', returnUrl);
    router.navigate(['./login']);
  };

  const handleRouteRedirection = (router: Router, route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const currentUrl = state.url;

    const reviewPrefixes = [
      '/apps/translationreview/',
      '/review/batchtranscriptionreview/',
      '/review/ata-tts-batch/',
      '/review/ata-transcription-batch/',
      '/review/ata-translation-batch/',
      '/review/translation/',
      '/review/audio/',
      '/review/copy-editing/',
      '/review/recording-lumo/',
      '/review/transcription-single/',
      '/review/transcription-multiple/',
      '/review/lumo-script-code/',
      '/review/adaptationreview/',
      '/review/video-adaptation/',
      '/review/dubbing/select-voices/',
    ];

    const match = reviewPrefixes.find(prefix => currentUrl.startsWith(prefix));
    if (match) {
      const replacePrefix = match.startsWith('/apps') ? '/apps' : '/review';
      router.navigate([currentUrl.replace(replacePrefix, '')]);
    } else {
      redirectToLogin(router, currentUrl);
    }
  };

  return from(
    new Promise<boolean>(async (resolve) => {
      if (securityService.securityObject.isAuthenticated) {
        resolve(true);
        return;
      }

      const refreshToken = localStorage.getItem('refreshToken');
      if (refreshToken) {
        try {
          await firstValueFrom(securityService.refreshRegularToken());
          resolve(true);
        } catch {
          redirectToLogin(router, state.url);
          resolve(false);
        }
      } else {
        handleRouteRedirection(router, route, state);
        resolve(false);
      }
    })
  ).pipe(
    map((result) => result),
    catchError((err) => {
      console.error('Error in authGuard.');
      redirectToLogin(router, state.url);
      return from([false]);
    })
  );
};
